<template>
    <div class="components-container">
        <div class="welcome-container" ref="mainArea">
            <div class="welcome-text-Container">
                欢迎进入{{ subsystemName }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                //subsystemName: '南湖学院教务教学管理系统',
				subsystemName: '教务教学管理系统',
            }
        },
        mounted() {
            if(localStorage.getItem('subsystemName')){
                this.subsystemName = localStorage.getItem('subsystemName');
            }
            
            this.$nextTick(function() {
                $('.welcome-container').css('height', window.innerHeight - this.$refs.mainArea.offsetTop - 100);
                // 监听窗口大小变化
                let _this = this;
                window.onresize = function() {
                    $('.welcome-container').css('height', window.innerHeight - _this.$refs.mainArea.offsetTop - 100);
                };
            });
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// welcome.vue?7286fd98